import React from 'react';
import { ReportLink } from '../reporting/ReportLink';
import { patientChartPath } from '../../utils/navigation';

export const PatientCell: React.FC<{
  name: string;
  mrn?: string | null;
  patientId?: string | null;
}> = ({ name, mrn, patientId }) => (
  <div className='flex flex-col'>
    {patientId ? (
      <ReportLink to={patientChartPath(patientId)}>{name}</ReportLink>
    ) : (
      <span>{name}</span>
    )}
    {mrn ? <span className='text-xs text-muted-foreground'>{mrn}</span> : null}
  </div>
);
